import { useFormContext } from 'react-hook-form'

import { spreadsheetFileTypes } from '@fortem-monorepo/constants'
import { FileUploadInput } from '@fortem-monorepo/react-ui'
import { SelectInput } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import { SchemaType } from '@/components/forms/AddAttributionEntryForm/AddAttributionEntryForm.schema'

const inputTypeOptions = [
  { label: 'Attributions - U:\\FundExtract\\ASW', value: 'attributions' },
  { label: 'Schedule - U:\\FundExtract\\Cash Flows.xlsx', value: 'schedule' },
  { label: 'JPM - U:\\FundExtract\\BankRatesRuns\\JPM', value: 'jpm' },
] as const

export interface AddAttributionEntryFormFieldsProps {}

export const AddAttributionEntryFormFields: React.FC<AddAttributionEntryFormFieldsProps> = ({}) => {
  const { setValue, control, formState, register } = useFormContext<SchemaType>()

  return (
    <div className={'flex flex-col gap-4'}>
      <FormField
        name="input_type"
        control={control}
        render={({ field: { value } }) => {
          return (
            <FormItem>
              <FormLabel>Input Type</FormLabel>
              <SelectInput
                size={'sm'}
                className={'w-full'}
                disabled={formState.isSubmitting}
                // @ts-expect-error
                options={inputTypeOptions}
                value={value}
                onValueChange={(val) =>
                  setValue('input_type', val as (typeof inputTypeOptions)[number]['value'], {
                    shouldValidate: true,
                  })
                }
              />
            </FormItem>
          )
        }}
      />
      <FormField
        name={'files'}
        control={control}
        render={({ field: { value } }) => {
          return (
            <FormItem>
              <FormLabel>Files</FormLabel>
              <FileUploadInput
                multiple={false}
                disabled={formState.isSubmitting}
                accept={spreadsheetFileTypes.join(',')}
                files={value}
                setValue={(files) => setValue('files', files, { shouldValidate: true })}
                {...register('files')}
              />
            </FormItem>
          )
        }}
      />
    </div>
  )
}
